module.exports = __webpack_public_path__ + "static/media/playlist-edit.7ebc6424.svg";